import { ExtraOptions, RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from './_services/authguard.service';
import { AuthorBioModalComponent } from './author-bio-modal/author-bio-modal.component';
import { BundleListComponent } from './bundle-list/bundle-list.component';
import { BundleViewComponent } from './bundle-view/bundle-view.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { CourseViewComponent } from './course-view/course-view.component';
import { CoursesAllComponent } from './courses-all/courses-all.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HelpPageComponent } from './help-page/help-page.component';
import { LandingCECenterComponent } from './landing-cecenter/landing-cecenter.component';
import { LoginComponent } from './login/login.component';
import { MarketingLandingComponent } from './marketing-landing/marketing-landing.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { NgModule } from '@angular/core';
import { NotFoundComponent } from './not-found/not-found.component';
import { ShoppingCartDisplayComponent } from './shopping-cart-display/shopping-cart-display.component';
import { StyleGuideComponent } from './style-guide/style-guide.component';
import { TranscriptComponent } from './transcript/transcript.component';

const routes: Routes = [
  { path: 'styleguide', component: StyleGuideComponent },
  { path: 'login', component: LoginComponent },
  { path: 'pricing', component: MarketingLandingComponent },
  { path: '', component: DashboardComponent },
  { path: 'courses', component: CoursesAllComponent, data: { animation: true } },
  { path: 'course', loadChildren: () => import('./_modules/course-view/course-view.module').then(m => m.CourseViewModule) },
  { path: 'help', loadChildren: () => import('./_modules/course-view/course-view.module').then(m => m.CourseViewModule) },
  { path: 'myaccount', component: MyAccountComponent, data: { animation: true }, canActivate: [AuthGuardService] },
  { path: 'author/:id', component: AuthorBioModalComponent, data: { animation: true } },
  { path: 'packages', component: BundleListComponent, data: { animation: true } },
  { path: 'package/:alias', component: BundleViewComponent, data: { animation: true }, },
  { path: 'transcript', component: TranscriptComponent, canActivate: [AuthGuardService] },
  { path: 'cecenter', component: LandingCECenterComponent },
  { path: 'cart', component: ShoppingCartDisplayComponent, canActivate: [AuthGuardService] },
  { path: 'cart/checkout', component: CheckoutComponent, canActivate: [AuthGuardService] },
  { path: '**', component: NotFoundComponent },
];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 64],
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
